// extracted by mini-css-extract-plugin
module.exports = {"pageFooter":"styles_pageFooter__ODUzn","textContainer":"styles_textContainer__z_x99","text":"styles_text__rgap5","imageContainer":"styles_imageContainer__67CKM"};